module.exports = __webpack_public_path__ + "static/img/9.4cd673d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/eng/9.png
// module id = kyvT
// module chunks = 0